export function stringIsNullOrEmpty(str) {
  let result = str === undefined || str === '';
  return result;
};

export function DistinctArray(array) {
  let obj = {};
  array.forEach((item) => {
    obj[item] = true;
  })

  return Object.keys(obj);
}

export function AverageArray(array){
  if(array.length === 0){
    return 0.00;
  }

  let sum = 0;
  for(let item of array){
    if(Number(item) === 0){
      continue;
    }
    if(!Number(item)){
      throw "array item is not Number. "+item;
    }

    sum += Number(item);
  }

  return sum / array.length;
}

export function assembleUrl(url, parameterDict) {
  let result = url;
  let isFirst = true;
  for (let key in parameterDict) {
    if (isFirst) {
      isFirst = false;
      result = result + '?';
    } else {
      result = result + '&';
    }

    result = result + key + '=' + parameterDict[key];
  }

  return result;
}

export function newtonsoftJsonToDate(json) {
  try {
    let date = json.split('T')[0];
    let time = json.split('T')[1].split('+')[0];

    let year = parseInt(date.split('-')[0]);
    let month = parseInt(date.split('-')[1]) - 1;
    let day = parseInt(date.split('-')[2]);

    let hour = parseInt(time.split(':')[0]);
    let minute = parseInt(time.split(':')[1]);
    let second = parseInt(time.split(':')[2].split('.')[0]);

    return new Date(year, month, day, hour, minute, second);
  }
  catch
  {
    return undefined;
  }
}

export function StatisticsDateToDate(statisticsDate) {
  try {
    let target = statisticsDate.replace(' ', '');

    let yearIndex = target.indexOf('年');
    let year = 0;
    if (yearIndex >= 0) {
      year = parseInt(target.slice(0, yearIndex));
      if (year < 100) {
        year = year + 2000;
      }
      target = target.slice(yearIndex + 1);
    }

    let monthIndex = target.indexOf('月');
    let month = 0;
    if (monthIndex >= 0) {
      month = parseInt(target.slice(0, monthIndex));
      month = month - 1;
      target = target.slice(monthIndex + 1);
    }

    let dayIndex = target.indexOf('日');
    let day = 0;
    if (dayIndex >= 0) {
      day = parseInt(target.slice(0, dayIndex));
      target = target.slice(dayIndex + 1);
    }

    let hourIndex = target.indexOf('时');
    let hour = 0;
    if (hourIndex >= 0) {
      hour = parseInt(target.slice(0, hourIndex));
      target = target.slice(hourIndex + 1);
    }

    let minIndex = target.indexOf('分');
    let min = 0;
    if (minIndex >= 0) {
      min = parseInt(target.slice(0, minIndex));
      target = target.slice(minIndex + 1);
    }

    let secondIndex = target.indexOf('秒');
    let second = 0;
    if (secondIndex >= 0) {
      second = parseInt(target.slice(0, secondIndex));
      target = target.slice(secondIndex + 1);
    }

    return new Date(year, month, day, hour, min, second);
  }
  catch {
    return undefined;
  }
}

export function dateTimeToString(date, format) {
  try {
    let result = format;

    result = result.replace('yyyy', date.getFullYear().toString());
    result = result.replace('YYYY', date.getFullYear().toString());

    result = result.replace(
      'yy',
      date
        .getFullYear()
        .toString()
        .substr(2, 2)
    );
    result = result.replace(
      'YY',
      date
        .getFullYear()
        .toString()
        .substr(2, 2)
    );

    let month = date.getMonth() + 1;
    let fullMonth = month;
    if (fullMonth < 10) {
      fullMonth = '0' + fullMonth;
    }
    result = result.replace('MM', fullMonth);
    result = result.replace('M', month);

    let day = date.getDate();
    let fullDay = day;
    if (fullDay < 10) {
      fullDay = '0' + fullDay;
    }
    result = result.replace('dd', fullDay);
    result = result.replace('DD', fullDay);
    result = result.replace('d', day);
    result = result.replace('D', day);

    let hour = date.getHours();
    let fullHour = hour;
    let amPmHour = hour;
    let fullAmPmHour = hour;
    if (amPmHour > 12) {
      amPmHour = amPmHour - 12;
    }
    if (fullAmPmHour > 12) {
      fullAmPmHour = fullAmPmHour - 12;
    }
    if (fullHour < 10) {
      fullHour = '0' + fullHour;
    }
    if (fullAmPmHour < 10) {
      fullAmPmHour = '0' + fullAmPmHour;
    }
    result = result.replace('HH', fullHour);
    result = result.replace('hh', fullAmPmHour);
    result = result.replace('H', hour);
    result = result.replace('h', amPmHour);

    let minute = date.getMinutes();
    let fullMinute = minute;
    if (fullMinute < 10) {
      fullMinute = '0' + fullMinute;
    }
    result = result.replace('mm', fullMinute);
    result = result.replace('m', minute);

    let second = date.getSeconds();
    let fullSecond = second;
    if (fullSecond < 10) {
      fullSecond = '0' + fullSecond;
    }
    result = result.replace('ss', fullSecond);
    result = result.replace('SS', fullSecond);
    result = result.replace('s', second);
    result = result.replace('S', second);

    return result;
  } catch
  {
    return '';
  }
}